<script>
  export let logo;
</script>

<style>
  .header {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: flex-end; /* Align at the bottom */
    padding: 0 20px;
    border-bottom: 2px solid #e0e0e0;
    position: relative; /* Enable absolute positioning for the logo */
    height: 80px; /* Adjust header height as needed */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .logo-container {
    position: absolute;
    top: 30%; /* Adjust to hang slightly off the header */
    width: 100px; /* Adjust size as needed */
  }

  .logo-container img {
    width: 100%; /* Maintain aspect ratio */
    object-fit: contain;
  }
</style>

<div class="header">
  <div class="logo-container">
    <img src={logo} alt="Logo" />
  </div>
</div>
